export const filterOutById = <T extends { id: any }>(id: T['id']) => {
  return (data: T[] | undefined) => data?.filter(item => item.id !== id);
};
